var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'spinner' + (_vm.theme !== '' ? ' spinner--' + _vm.theme : '')})
}
var staticRenderFns = []

export { render, staticRenderFns }